
import React from "react";
import { ActivationFolderIcon  } from "../../icons-svg";

const TabActivationFolderButton = ({ tooltip = "Save", children, ...props }) => {
  return (
    <div className="relative inline-block group">
      <button
        {...props}
        className="py-2 px-2 text-center text-green-500 bg-transparent focus:outline-none focus:ring-0"
      >
        {children || <ActivationFolderIcon  className="h-4 w-4" />}
      </button>
      {tooltip && (
        <span
          className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2
           opacity-0 group-hover:opacity-100
           bg-white text-black text-xs rounded px-2 py-1
           border border-black
           pointer-events-none transition-opacity duration-200 ease-in-out
           whitespace-nowrap z-50 shadow-md"
        >
          {tooltip}
        </span>
      )}
    </div>
  );
};

export default TabActivationFolderButton;

